'use client'
import Image from 'next/image'
import { parseAsString, useQueryStates } from 'nuqs'

import searchIcon from '@/public/icons/search.svg'
export default function Search({ searchKey }: { searchKey?: string }) {
  searchKey = searchKey || 'q'
  const [state, setState] = useQueryStates(
    {
      [`${searchKey}`]: parseAsString.withDefault(''),
      page: parseAsString.withDefault('1'),
    },
    {
      shallow: false,
      throttleMs: 500,
    }
  )

  return (
    <div className={`
      flex w-full flex-row gap-5 rounded-md p-2 border-2 border-[#D4D8E3] bg-white

     
    `}>
      <Image src={searchIcon} alt='search' height={20} width={20} />
      <input
        type='text'
        value={state[`${searchKey}`]}
        onChange={(e) => setState({ [`${searchKey}`]: e.target.value, page: '1' })}
        className={`
          w-full text-base text-black outline-none font-normal bg-white

          placeholder:text-base
        `}
        placeholder='Search'
      />
    </div>
  )
}
